import { z } from "zod";
import { responsiveValue } from "../../common/schema";
function responsiveStyle(color) {
  return responsiveValue(
    z.object({
      fontFamily: z.string().nullable().optional(),
      lineHeight: z.number().nullable().optional(),
      letterSpacing: z.number().nullable().optional(),
      fontWeight: z.number().nullable().optional(),
      textAlign: z.string().nullable().optional(),
      uppercase: z.boolean().nullable().optional(),
      underline: z.boolean().nullable().optional(),
      strikethrough: z.boolean().nullable().optional(),
      italic: z.boolean().nullable().optional(),
      fontSize: z.object({
        value: z.number().nullable(),
        unit: z.string().nullable()
      }).nullable().optional(),
      color: color.optional()
    })
  );
}
const resolvedStyle = responsiveStyle(
  z.object({
    swatch: z.object({
      hue: z.number(),
      saturation: z.number(),
      lightness: z.number()
    }).optional(),
    alpha: z.number().optional()
  }).optional()
);
function typography(color) {
  return z.object({
    id: z.string().optional(),
    style: responsiveStyle(color)
  });
}
export {
  resolvedStyle,
  responsiveStyle,
  typography
};
//# sourceMappingURL=schema.js.map